import{useContext}from'react';import AuthContext from'./auth-context';var useAuth=function useAuth(){return useContext(AuthContext);};export{useAuth};